import steps from './steps/steps';
import stepsMobile from './steps/steps-mobile';

stepsMobile();
steps(document.querySelector('.er_steps'), window);
